import React from 'react';
import { Link } from 'react-router-dom';
import styles from './styles/UserCard.module.css';
import profileIcon from '../../images/profileicon.png';

const UserCard = ({ user }) => {
    return (
        <div className={styles.userCard}>
            <div className={styles.profileImageContainer}>
                <img
                    src={user.profilePicture ? user.profilePicture : profileIcon}
                    alt={`${user.username}'s profile`}
                    className={styles.profileImage}
                />
            </div>
            <div className={styles.userInfoContainer}>
                <h3 className={styles.username}>
                    <Link to={`/user/${user.username}`} className={styles.usernameLink}>
                        {user.username}
                    </Link>
                </h3>
            </div>
        </div>
    );
};

export default UserCard;
